const lang = {
  breadcrumb: {
    management: 'シミュレーション結果',
    details: 'シミュレーション結果詳細',
    operation_history: '施業履歴',
  },
  exec_simulation: 'シミュレーション実行',
  select_all: '一括選択',
  unselect_all: '一括解除',
  list: {
    page_title: 'シミュレーション結果',
    paginate_text: '{total} 件中 {from} 件 〜 {to} 件を表示',
    multiple_area_selection_mode: '複数区域選択モード',
    simulation: {
      defaultText: 'シミュレーションを選択してください',
    },
    filter: {
      condition: '絞り込み条件',
      achieved_monthly_profit: 'ヶ月以内に単月黒字化',
      profitable_month_default: '12',
      total_sales_over_five_years: '売上総額が',
      yen_or_more: '円以上',
      total_sales_default: '10000000',
      credit_emissions: 'クレジット排出量',
      ton_or_more: 't以上',
      credit_emissions_default: '1000',
    },
    search: {
      simulation: 'シミュレーション設定',
      free_word: 'フリーワード検索',
    },
    label: {
      no: 'No',
      complex_name: '団地',
      forest_group: '林班',
      small_forest_group: '小班',
      branch_group: '小班枝番',
      compensate_group: '小班補番',
      tree_species: '樹種',
      areas: '面積（ha）',
      total_sales: '売上総額（円）',
      co2_absorption_amount: 'CO2吸収量（t）',
      thinning_period: '施業履歴間伐時期（年）',
      planned_thinning_period: '間伐計画時期（年）',
      rerun: '選択区域でシミュレーション再実行',
      select_all: '一括選択',
      unselect_all: '一括解除',
    },
    register_request: {
      title: {
        setting: '登録申請リスト表示名設定',
        complete: '登録申請リスト追加完了',
      },
      explain: {
        setting: '登録申請リストに表示されるタイトルを設定してください。',
        complete: '登録申請リストへの追加が正常に完了しました。詳細は、「登録申請 リスト」画面にてご確認ください。',
      },
      add: '+登録申請リスト追加',
      save: '保存',
      cancel: 'キャンセル',
      close: '閉じる',
      fixed_value: '想定売上：1,222,333円 /クレジット排出量：100.00トン',
    },
  },
  forest_information: {
    table_title: '選択中の森林情報',
    forest_age: '(樹齢) ',
    tree_height: '(樹高) ',
    breast_height_diameter: '(胸高直径) ',
    position: '(地位) ',
    accumulation: '(材積量) ',
    growth_rate: '(成長率) ',
    tree_volume_increment: '(材積成長量) ',
    tree_information: '(樹種情報) ',
    operation_history: '(施業履歴) ',
    fixed_value: {
      forest_age: '74歳',
      tree_height: '22m',
      breast_height_diameter: 'ー',
      position: '2',
      accumulation: '810',
      growth_rate: '8.5',
      tree_volume_increment: '8.5',
      tree_information: 'スギ：2,100本 / 100%',
      operation_history: '2023年実施・間伐・5.07ha',
    },
  },
  selecting_simulation_result: '選択中のシミュレーション結果',
}

export default lang
